<template>
  <el-dialog
    :title="isEdit ? '编辑用户' : '添加用户'"
    :visible="visible"
    width="30%"
    append-to-body
    :before-close="closeDialog"
  >
    <el-form
      :model="formState"
      :rules="rules"
      ref="formRef"
      label-width="120px"
    >
      <el-form-item label="身份证号" prop="idcard">
        <el-input
          v-model="formState.idcard"
          placeholder="请输入身份证号"
        ></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="formState.name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="项目" prop="project">
        <el-input
          v-model="formState.project"
          placeholder="请输入项目"
        ></el-input>
      </el-form-item>
      <el-form-item label="组别" prop="group">
        <el-input v-model="formState.group" placeholder="请输入组别"></el-input>
      </el-form-item>
      <el-form-item label="等级" prop="grade">
        <el-input v-model="formState.grade" placeholder="请输入等级"></el-input>
      </el-form-item>
      <el-form-item label="日期" prop="date">
        <el-input v-model="formState.date" placeholder="请输入日期"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input
          v-model="formState.address"
          placeholder="请输入地址"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确定</el-button>
      <el-button @click="closeDialog">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { cloneDeep } from "lodash";
import { addWallHonorUser, editWallHonorUser } from "@/api/honor";

export default {
  data() {
    return {
      isEdit: false, // 是否编辑
      visible: false,
      formState: {
        honor_id: "",
        idcard: "",
        name: "",
        project: "",
        group: "",
        grade: "",
        date: "",
        address: "",
      },
      rules: {
        idcard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!/^\d{17}[\dXx]|\d{15}$/.test(value)) {
                callback(new Error("请输入正确的身份证号"));
              } else {
                callback();
              }
            },
          },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        project: [{ required: true, message: "请输入项目", trigger: "blur" }],
        group: [{ required: true, message: "请输入组别", trigger: "blur" }],
        grade: [{ required: true, message: "请输入等级", trigger: "blur" }],
        date: [{ required: true, message: "请输入日期", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
      },
    };
  },
  methods: {
    openDialog(data) {
      this.visible = true;
      this.resetForm();
      this.formState = cloneDeep(data);
      if (data.idcard) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
    },
    closeDialog() {
      this.visible = false;
    },
    resetForm() {
      this.formState = {
        honor_id: "",
        idcard: "",
        name: "",
        project: "",
        group: "",
        grade: "",
        date: "",
        address: "",
      };
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      });
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            editWallHonorUser(this.formState).then((res) => {
                console.log("_result", res);
              if (res.data.result === 1) {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.$emit("updateSuccess");
                this.closeDialog();
              }
            });
          } else {
            addWallHonorUser(this.formState).then((res) => {
                console.log("_result", res);
              if (res.data.result === 1) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.$emit("addSuccess");
                this.closeDialog();
              }
            });
          }
          console.log("submit", this.formState);
        } else {
          this.$message({
            message: "请填写完整信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>
